import React from 'react';
import ReactModal from '../Modal';
import { withTranslation } from 'react-i18next';

class PagesModal extends React.Component {
    constructor() {
        super();
    }

    render() {
        const { t } = this.props;
        return (
            <>
                <ReactModal
                    modalState={this.props.isOpen}
                    className="width-sm"
                    onClose={this.props.onClose}
                >
                    <h2>{t('discover.entity_clusters.modal.header')}</h2>
                    <div className="pages-modal-container">
                        {this.props.pages?.map((item) => {
                            return (
                                <div className="pages-modal-container-item" key={item}>
                                    <a href={item} target="_blank" rel="noreferrer">
                                        {item}
                                    </a>
                                </div>
                            );
                        })}
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <button
                            type="button"
                            className="button button-outline button-primary width-sm btn"
                            onClick={this.props.onClose}
                            style={{ lineHeight: 'unset' }}
                        >
                            {t('discover.entity_clusters.modal.close')}
                        </button>
                    </div>
                </ReactModal>
            </>
        );
    }
}

export default withTranslation()(PagesModal);
